<template>
    <div class="question-item" ref="container">
        <div class="match-container">
            <!-- 左侧选项 -->
            <div class="left-panel">
                <div
                    v-for="item in leftOptions"
                    :key="item.id"
                    :class="[
                        'option-item',
                        { selected: selectedItem && selectedItem.id === item.id, matched: item.matched },
                    ]"
                    @click="handleLeftClick(item)"
                    :id="`left-${item.id}`"
                >
                    <span class="option-content">{{ item.indexNo }}. {{ item.content }}</span>
                </div>
            </div>

            <!-- 连线画布 -->
            <svg class="canvas" ref="canvas">
                <line
                    v-for="line in lines"
                    :key="line.id"
                    :x1="line.x1"
                    :y1="line.y1"
                    :x2="line.x2"
                    :y2="line.y2"
                    class="line"
                />
            </svg>

            <!-- 右侧选项 -->
            <div class="right-panel">
                <div
                    v-for="item in rightOptions"
                    :key="item.id"
                    :class="[
                        'option-item',
                        { selected: selectedItem && selectedItem.id === item.id, matched: item.matched },
                    ]"
                    @click="handleRightClick(item)"
                    :id="`right-${item.id}`"
                >
                    <span class="option-content">{{ item.content }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['question'],
    data() {
        return {
            leftOptions: [],
            rightOptions: [],
            selectedItem: null,
            selectedSide: null, // 'left' or 'right'
            lines: [],
            matches: [],

            cacheMatchMap: {},
        }
    },
    created() {
        this.initOptions()
    },
    mounted() {
        window.addEventListener('resize', this.updateLines)
        this.$nextTick(() => {
            this.updateLines()
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateLines)
    },
    watch: {
        question() {
            this.initOptions()
            this.clearMatches()
        },
    },
    methods: {
        initOptions() {
            if (!this.question) return

            // 左侧选项（子问题）
            this.leftOptions = this.question.childQuestions.map((item) => ({
                ...item,
                matched: false,
            }))

            // 右侧选项（答案）
            this.rightOptions = this.question.options.map((item) => ({
                ...item,
                matched: false,
            }))
            this.initStashAnswer()
        },

        initStashAnswer() {
            this.leftOptions.forEach((item) => {
                if (!item.stashAnswer) return
                let opt = this.rightOptions.find((i) => {
                    if (i.title === item.stashAnswer[0]) {
                        i.matched = true
                    }
                    return i.title === item.stashAnswer[0]
                })
                item.matched = true
                this.matches.push({
                    id: `${item.id}-${opt.id}`,
                    left: item,
                    right: opt,
                })
            })
            // 如果有预置答案，更新连线
            if (this.matches.length > 0) {
                this.$nextTick(() => {
                    this.updateLines()
                })
                this.emitAnswer()
            }
        },

        handleLeftClick(item) {
            // 如果点击已匹配的项，取消匹配
            if (item.matched) {
                this.removeMatchByItem(item)
                return
            }

            // 清除之前的选中
            if (this.selectedSide === 'right' && this.selectedItem) {
                this.selectedItem = null
                this.selectedSide = null
            }

            if (this.selectedSide === 'left' && this.selectedItem && this.selectedItem.id === item.id) {
                // 取消选中
                this.selectedItem = null
                this.selectedSide = null
            } else {
                // 选中左侧
                this.selectedItem = item
                this.selectedSide = 'left'
            }
        },

        handleRightClick(item) {
            // 如果点击已匹配的项，取消匹配
            if (item.matched) {
                this.removeMatchByItem(item)
                return
            }

            if (this.selectedSide === 'left' && this.selectedItem) {
                // 创建连线
                this.createMatch(this.selectedItem, item)

                // 清除选中
                this.selectedItem = null
                this.selectedSide = null
            } else if (this.selectedSide === 'right' && this.selectedItem && this.selectedItem.id === item.id) {
                // 取消选中
                this.selectedItem = null
                this.selectedSide = null
            } else {
                // 选中右侧
                this.selectedItem = item
                this.selectedSide = 'right'
            }
        },

        removeMatchByItem(item) {
            // 查找包含该选项的匹配
            const matchIndex = this.matches.findIndex((m) => m.left.id === item.id || m.right.id === item.id)

            if (matchIndex !== -1) {
                this.removeMatch(matchIndex)
            }
            // 更新答案状态
            this.emitAnswer('edit')
        },

        createMatch(leftItem, rightItem) {
            const matchId = `${leftItem.id}-${rightItem.id}`

            // 检查是否已经存在连线
            const existingIndex = this.matches.findIndex(
                (m) => m.left.id === leftItem.id || m.right.id === rightItem.id
            )

            if (existingIndex !== -1) {
                // 如果已有连线，先删除
                this.removeMatch(existingIndex)
            }

            // 添加新连线
            this.matches.push({
                id: matchId,
                left: leftItem,
                right: rightItem,
            })

            // 更新匹配状态
            leftItem.matched = true
            rightItem.matched = true

            // 更新连线
            this.$nextTick(() => {
                this.updateLines()
            })

            // 触发事件
            this.emitAnswer('edit')
        },

        removeMatch(index) {
            const match = this.matches[index]
            match.left.matched = false
            match.right.matched = false
            this.matches.splice(index, 1)

            this.$nextTick(() => {
                this.updateLines()
            })
        },

        clearMatches() {
            this.leftOptions.forEach((item) => (item.matched = false))
            this.rightOptions.forEach((item) => (item.matched = false))
            this.matches = []
            this.lines = []
            this.selectedItem = null
            this.selectedSide = null
        },

        updateLines() {
            const newLines = []
            const canvasRect = this.$refs.canvas.getBoundingClientRect()

            if (!canvasRect) return

            this.matches.forEach((match) => {
                const leftEl = document.getElementById(`left-${match.left.id}`)
                const rightEl = document.getElementById(`right-${match.right.id}`)

                if (leftEl && rightEl) {
                    const leftRect = leftEl.getBoundingClientRect()
                    const rightRect = rightEl.getBoundingClientRect()

                    // 计算连线坐标（相对于画布）
                    const x1 = leftRect.right - canvasRect.left
                    const y1 = leftRect.top + leftRect.height / 2 - canvasRect.top
                    const x2 = rightRect.left - canvasRect.left
                    const y2 = rightRect.top + rightRect.height / 2 - canvasRect.top

                    newLines.push({
                        id: match.id,
                        x1,
                        y1,
                        x2,
                        y2,
                    })
                }
            })

            this.lines = newLines
        },

        emitAnswer(type) {
            const matchMap = {}
            this.matches.forEach((match) => {
                matchMap[match.left.id] = match.right
            })

            this.leftOptions.forEach((item) => {
                const matchedRight = matchMap[item.id]
                const newAnswer = matchedRight ? matchedRight.title : null
                const cachedAnswer = this.cacheMatchMap[item.id] || null
                if (cachedAnswer !== newAnswer) {
                    this.$store.dispatch('paperDetails/setUserAnswerMap', {
                        [`q-${item.id}`]: matchedRight ? { state: true, answer: [matchedRight.title] } : null,
                    })
                    if (type === 'edit') {
                        this.$store.dispatch('paperDetails/updateUserAnswer', {
                            id: item.id,
                            answer: matchedRight ? [matchedRight.title] : [],
                        })
                    }
                }
            })

            // 更新缓存
            this.updateCacheMatchMap()
        },
        updateCacheMatchMap() {
            this.cacheMatchMap = {}
            this.matches.forEach((match) => {
                this.cacheMatchMap[match.left.id] = match.right.title
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.question-item {
    padding: 20px;
}

.match-container {
    display: flex;
    justify-content: space-between;
    position: relative;
    min-height: 300px;
    align-items: center;
}

.left-panel,
.right-panel {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: calc(50% - 60px);
    z-index: 1;
    height: 100%;
    justify-content: center;
}

.option-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 20px;
    background: #cccccc;
    border: 2px solid transparent;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;

    &:hover {
        background: #f0f0f0;
        border-color: #ddd;
    }

    &.selected {
        background: rgba(255, 140, 0, 0.08);
        border-color: #ff8c00;
    }

    &.matched {
        background: rgba(76, 175, 80, 0.08);
        border-color: #4caf50;
        opacity: 0.8;
    }
}

.option-content {
    flex: 1;
    font-size: 15px;
    line-height: 1.5;
    color: #333;
    word-break: break-word;
}

.canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 0;
}

.line {
    stroke: #4caf50;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-dasharray: 1000;
    stroke-dashoffset: 1000;
    animation: drawLine 0.3s ease forwards;
}

@keyframes drawLine {
    to {
        stroke-dashoffset: 0;
    }
}

// 移动端适配
@media (max-width: 768px) {
    .match-container {
        min-height: 250px;
    }

    .left-panel,
    .right-panel {
        width: calc(50% - 40px);
        gap: 12px;
    }

    .option-item {
        padding: 12px 16px;
    }

    .option-content {
        font-size: 14px;
    }
}
</style>
